import React, { useEffect } from 'react';
import {
  Center,
  Image,
  Grid,
  Box,
  Link,
  Container,
  Flex,
  Text,
} from '@chakra-ui/react';
import Footer from './Footer';
import ScrollToTopForRouter from '../components/common/ScrollToTopForRouter';
import logoSrc from '../assets/vectors/logo.svg';
import logoLightSrc from '../assets/images/logo-light.png';
import iconLightSrc from '../assets/images/icon-light.svg';
import { FORM_PADDING_TOP_XL } from '../utils/consts';
import { ArrowBackIcon } from '@chakra-ui/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  captureTrackingParams,
  withTrackingParams,
  trackingSearch,
} from '../utils/trackingParams';

const LayoutAuth = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const formPaddingTop = props.formPaddingTop ?? { base: 0, md: 24 };

  useEffect(() => {
    captureTrackingParams();
  }, [location.search]);

  return (
    <>
      <ScrollToTopForRouter />
      <Grid templateColumns={{ base: '1fr', md: '35vw 65vw' }} minH="100vh">
        {/* Left column  */}
        <Box
          display={{ base: 'none', md: 'block' }}
          bg="linear-gradient(180deg, #FF9554 16%, #FF6F45 55%, #FF4935 88%)"
          color="white"
          position="relative"
          p={6}
        >
          <Link
            isExternal
            href={withTrackingParams('https://passentry.com')}
            textDecoration="none"
          >
            <Image src={logoLightSrc} alt="logo" w="180px" />
          </Link>
          <Center h="85%">
            <Image src={iconLightSrc} alt="sign-up" w="60%" h="60%" />
          </Center>
        </Box>

        {/* Right column */}
        <Container bg="#F8F8F8" w={{ base: '100vw', md: '65vw' }} p={0}>
          <Flex direction="column" minH="100vh" position="relative">
            {/* Back link */}
            {props.backLink && (
              <Flex
                direction="row"
                w="100%"
                align="center"
                gap={1}
                cursor="pointer"
                justifyContent="flex-start"
                onClick={() => {
                  navigate(`/login${trackingSearch()}`);
                }}
                display={{ base: 'none', md: 'flex' }}
                pt={4}
                px={4}
              >
                <ArrowBackIcon />
                <Text textStyle="headingFamilyMedium" fontSize="16px" mt={0.5}>
                  Back
                </Text>
              </Flex>
            )}
            {/* Mobile logo */}
            <Box
              position="absolute"
              top={4}
              left={4}
              display={{ base: 'block', md: 'none' }}
              zIndex={1}
            >
              <Link href={withTrackingParams('/')}>
                <Image src={logoSrc} alt="logo" w="160px" />
              </Link>
            </Box>
            <Box
              pt={formPaddingTop ? FORM_PADDING_TOP_XL : 0}
              px={{ base: 6, md: '12vw' }}
              pb={6}
              flex="1"
            >
              {props.children}
            </Box>
            {/* Footer */}
            <Footer public />
          </Flex>
        </Container>
      </Grid>
    </>
  );
};

export default LayoutAuth;
